import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, TrendingUp, BarChart3, Activity } from 'lucide-react';
const stats = [{
  label: 'Total Market Cap',
  value: '$2.84T',
  change: -1.2,
  icon: <BarChart3 size={16} className="text-brand-purple-light" data-id="element-1281" />
}, {
  label: '24h Volume',
  value: '$142.5B',
  change: null,
  icon: <Activity size={16} className="text-brand-purple-light" data-id="element-1282" />
}, {
  label: 'BTC Dominance',
  value: '52.4%',
  change: null,
  icon: <img src="https://cryptologos.cc/logos/bitcoin-btc-logo.svg" alt="BTC" className="w-4 h-4" data-id="element-1283" />
}, {
  label: 'Fear & Greed Index',
  value: '68',
  subtitle: 'Greed',
  indicatorColor: 'bg-warning',
  icon: <TrendingUp size={16} className="text-warning" data-id="element-1284" />
}];
export function MarketStatsBar() {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-1285">
      {stats.map((stat, i) => <motion.div key={stat.label} initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.35,
      delay: i * 0.06
    }} className="glass-border rounded-[20px] p-4" data-id="element-1286">
          <div className="flex items-center justify-between mb-2" data-id="element-1287">
            <span className="text-[10px] font-label text-text-tertiary uppercase" data-id="element-1288">
              {stat.label}
            </span>
            <div className="p-1.5 bg-background-elevated rounded-lg" data-id="element-1289">
              {stat.icon}
            </div>
          </div>
          <div className="flex items-baseline gap-2" data-id="element-1290">
            <span className="text-xl font-numbers text-text-primary font-light" data-id="element-1291">
              {stat.value}
            </span>
            {stat.change !== null && stat.change !== undefined && <span className={`flex items-center gap-0.5 text-xs font-numbers ${stat.change >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-1292">
                {stat.change >= 0 ? <TrendingUp size={12} data-id="element-1293" /> : <TrendingDown size={12} data-id="element-1294" />}
                {stat.change >= 0 ? '+' : ''}
                {stat.change}%
              </span>}
            {stat.subtitle && <span className="flex items-center gap-1.5 text-xs font-ui text-warning" data-id="element-1295">
                <span className={`w-2 h-2 rounded-full ${stat.indicatorColor}`} data-id="element-1296" />
                {stat.subtitle}
              </span>}
          </div>
        </motion.div>)}
    </div>;
}